/**
 * Carrier tracking-URL detection.
 *
 * Returns { url, carrier } for a given tracking number based on its format.
 * Supports USPS, UPS, FedEx — the three carriers Wilvada uses via ShipStation.
 * If we can't infer a carrier, we fall back to a Google search for the number.
 */

const isUSPS = (n) =>
  /^9[24]\d{18,20}$/.test(n) ||           // 9400/9405/9407 22-char
  /^[A-Z]{2}\d{9}US$/.test(n) ||          // International
  /^\d{20,22}$/.test(n) ||                // Generic USPS 22-digit
  /^E\w{1}\d{9}\w{2}$/.test(n);

const isUPS = (n) =>
  /^1Z[0-9A-Z]{16}$/.test(n) ||           // Standard 1Z
  /^[KH]\d{10}$/.test(n);                 // UPS Mail Innovations

const isFedEx = (n) =>
  /^\d{12}$/.test(n) ||                   // FedEx Express
  /^\d{15}$/.test(n) ||                   // FedEx Ground
  /^\d{20}$/.test(n) ||                   // FedEx SmartPost
  /^96\d{20}$/.test(n);

export function carrierFor(trackingNumber) {
  if (!trackingNumber) return null;
  const n = String(trackingNumber).trim().toUpperCase().replace(/\s+/g, '');
  if (isUPS(n)) return 'UPS';
  if (isFedEx(n)) return 'FedEx';
  if (isUSPS(n)) return 'USPS';
  return 'Unknown';
}

export function carrierTrackingUrl(trackingNumber, carrierHint) {
  if (!trackingNumber) return null;
  const n = String(trackingNumber).trim();
  const carrier = (carrierHint || carrierFor(n) || 'Unknown').toLowerCase();
  switch (carrier) {
    case 'usps':
      return `https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=${encodeURIComponent(n)}`;
    case 'ups':
      return `https://www.ups.com/track?tracknum=${encodeURIComponent(n)}`;
    case 'fedex':
      return `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(n)}`;
    case 'dhl':
      return `https://www.dhl.com/us-en/home/tracking.html?tracking-id=${encodeURIComponent(n)}`;
    default:
      // Fallback: open in a Google search prefilled with the tracking number
      return `https://www.google.com/search?q=track+${encodeURIComponent(n)}`;
  }
}
